import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {AdminUserFilterModel} from "../../../../shared/model/request/admin-user-filter.model";
import {roles} from "../../../../shared/types/custom-types";
import {UserAdminComponentTypeEnum} from "../user-admin-component-type.enum";
import {BaseUtil} from "../../../../shared/utils/base.util";
import {UserRoleEnum} from "../../../../shared/enums/user-role.enum";

@Component({
    selector: 'app-user-filters',
    templateUrl: './user-filters.component.html',
    standalone: false
})
export class UserFiltersComponent implements OnInit {

  form: FormGroup;

  @Input({required: true, alias: 'componentType'}) componentType: UserAdminComponentTypeEnum
  protected readonly UserAdminComponentTypeEnum = UserAdminComponentTypeEnum;

  @Output('submitFilter') submitEmitter = new EventEmitter<AdminUserFilterModel>()

  protected readonly maxDate = new Date()
  protected readonly eventStatuses = BaseUtil.removeFromStatusExcept(roles(),
    [UserRoleEnum.MODERATOR, UserRoleEnum.ADMIN])

  constructor() {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    this.form = new FormGroup<any>({
      "email": new FormControl(null),
      "firstname": new FormControl(null),
      "lastname": new FormControl(null),
      "role": new FormControl(null),
      "status": new FormControl(null),
      "creationDate": new FormControl(null),
    })
  }

  onClear() {
    this.form.reset()
    this.onSubmit();
  }

  onSubmit() {
    this.submitEmitter.emit(this.form.value)
  }

}
